import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@hellodarwin/core/lib/components/common/button';
import Div from '@hellodarwin/core/lib/components/common/div';
import Typography from '@hellodarwin/core/lib/components/common/typography';
import { useLocation } from '@hellodarwin/core/lib/features/providers/location-provider';
import { useTranslations } from '@hellodarwin/core/lib/features/providers/translations-provider';
import theme from '@hellodarwin/core/lib/theme';
import Attachment from '@hellodarwin/icons/dist/icons/Attachment';
import Download from '@hellodarwin/icons/dist/icons/Download';
import Expand from '@hellodarwin/icons/dist/icons/Expand';
import Empty from 'antd/lib/empty';
import { useMemo } from 'react';
import { useGinSteps } from '../../../gin-steps-provider';
const GinStepExampleAssetContent = ({ fileResponse, name, }) => {
    const location = useLocation();
    const { formState, downloadAsset } = useGinSteps();
    const { t } = useTranslations();
    const pdfHref = useMemo(() => {
        if (!fileResponse || fileResponse.extension !== '.pdf')
            return undefined;
        const currentPath = location.pathname.replace(/\/$/, '');
        return `${currentPath}/pdf/${fileResponse.asset_id}`;
    }, [fileResponse, location]);
    const handleDownload = useMemo(() => async () => {
        if (!fileResponse) {
            return;
        }
        try {
            const url = (await downloadAsset(fileResponse.asset_id, name)).link;
            window.open(url, 'download');
        }
        catch (error) {
            console.error(error);
        }
    }, [fileResponse, name, downloadAsset]);
    if (!fileResponse || !name) {
        return (_jsx(Empty, { description: _jsx(Typography, { elementTheme: "subtitle2", color: theme.colors.grey_2, children: t('gin_steps|no_example_asset') }) }));
    }
    return (_jsxs(Div, { style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'left',
            gap: 8,
        }, children: [_jsx(Attachment, { size: 20, color: formState === 'building' ? theme.colors.grey_1 : theme.colors.purple_1 }), _jsx(Div, { fitContent: true, children: _jsx("a", { href: pdfHref, target: "_blank", rel: "noopener noreferrer", children: _jsxs(Typography, { elementTheme: "caption", bold: true, style: {
                            color: formState === 'building'
                                ? theme.colors.grey_1
                                : theme.colors.purple_1,
                        }, children: [name, fileResponse.extension &&
                                ` (${fileResponse.extension.replace('.', '')})`, fileResponse.file_size && ` - ${fileResponse.file_size}`] }) }) }), _jsx(Div, { style: {
                    flex: 1,
                    borderBottom: `1px dotted ${formState === 'building' ? theme.colors.grey_1 : theme.colors.purple_1}`,
                    position: 'relative',
                    top: '8px',
                } }), pdfHref && (_jsx("a", { href: pdfHref, target: "_blank", rel: "noopener noreferrer", children: _jsx(Button, { size: "auto", transparent: true, headingIcon: _jsx(Expand, { size: 17.5, color: theme.colors.purple_1 }), style: {
                        color: theme.colors.transparent,
                    } }) })), _jsx(Button, { size: "auto", transparent: true, headingIcon: _jsx(Download, { size: 17.5, color: formState === 'building'
                        ? theme.colors.purple_1
                        : theme.colors.purple_2 }), onClick: handleDownload, disabled: !fileResponse, style: {
                    color: theme.colors.transparent,
                } })] }));
};
export default GinStepExampleAssetContent;
